import React from "react";

import NoEventResult from "../../../../images/library-events-icon-big.svg?react";
import NoResultsWithButton from "components/noResultsWithButton/NoResultsWithButton";

export interface EventsNoResultsProps {
  createEventButton?: React.ReactElement;
  filtered?: boolean;
  title?: string;
  description?: string;
}

const EventsNoResults: React.FC<EventsNoResultsProps> = ({ createEventButton, filtered, title, description }) => {
  return (
    <NoResultsWithButton
      title={title || "You don't have any events"}
      description={description || "Looks like you don't have any events."}
      icon={<NoEventResult />}
      actionButton={createEventButton}
      filtered={filtered}
    />
  );
};

export default EventsNoResults;
